<template>
  <div class="base-return">
      <div class="btn">
        <van-icon name="arrow-left"  size="22" @click="$router.back()" />
      </div>
    </div>
</template>

<script>
export default {
  name: 'GoBackView'
}
</script>

<style>

</style>
